import { enumSubChartFlag } from "../constants";

export class QBoxDataPair {
  constructor() {
    this.fLayout = null;
    this.fSerialDBObj = null;
  }

  InitFromObj(
    layout,
    origDBObj // , inTopChart) //, subChart
  ) {
    this.fLayout = layout.Clone();
    this.fSerialDBObj = origDBObj.SerialClone(true);
  }

  InitFromSerialObj(
    layout,
    serialObj //,  inTopChart) //serialSubChart,
  ) {
    this.fLayout = layout.Clone();
    this.fLayout.SetSubChartID(null);
    this.fSerialDBObj = serialObj.Clone();
  }

  GetParentID() {
    return this.fSerialDBObj.GetParentID();
  }

  IsDrillDown() {
    var scFlag = this.fLayout.GetSubChartFlag();
    return scFlag == enumSubChartFlag.drilldown;
  }
}
